import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TitleCasePipe } from '@angular/common';

import { SearchBase } from '../search-base';
import { SearchService } from '../search.service';
import { SharedFilterComponent } from './../../shared/shared-filter/shared-filter.component';
import { FormBuilder } from '@angular/forms';
import { GoogleAnalyticsEventsService } from './../../services/google-analytics-events.service';

@Component({
  selector: 'app-proceedings',
  templateUrl: './proceedings.component.html',
  styleUrls: ['./proceedings.component.scss', '../search.component.scss'],
  providers: [TitleCasePipe]
})
export class ProceedingsComponent extends SearchBase implements OnInit, OnDestroy {
  domain = 'proceedings';
  title = 'Proceedings';

  @ViewChild(SharedFilterComponent)
  sharedFilterComponent: SharedFilterComponent;

  constructor(
    protected searchService: SearchService,
    protected formBuilder: FormBuilder,
    protected route: ActivatedRoute,
    protected titlecasePipe: TitleCasePipe,
    protected googleAnalyticsService: GoogleAnalyticsEventsService,
    protected router: Router
  ) {
    super(searchService, formBuilder, titlecasePipe, googleAnalyticsService, route);
  }

  ngOnInit() {

    if (!this.sortMap) {
      this.sortMap = [{ sortColumnName: 'proceedingFilingDate', order: 'desc' }];
    }

    this.init();

  }

  ngOnDestroy() {
    this.destroy();
  }

  navigateToDocuments(proceedingNumber: string) {
    this.router.navigate(['search/documents'], {queryParams: {proceedingNumber: proceedingNumber}});
  }

}
